import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  wrapper: {
    display: 'flex',
    overflowY: 'auto',
    padding: '18px 40px 0',
    margin: '-18px 0 0',
    height: 'calc(100% - 125px)',
    ['@media (max-width:1010px)']: {
      padding: '18px 0 0 40px',
      height: 'calc(100% - 125px)'
    },
    ['@media (max-width:850px)']: {
      padding: '0 0 0 40px',
      margin: '0px',
      height: 'calc(100% - 113px)'
    },
    ['@media (max-width:600px)']: {
      padding: '0 15px 0 15px',
      height: 'calc(100% - 151px)',
      flexDirection: 'column-reverse'
    }
  },
  leftSide: {
    width: '100%',
    padding: '0 40px 0 1px',
    ['@media (max-width:1010px)']: {
      paddingRight: '40px'
    },
    ['@media (max-width:850px)']: {
      marginTop: 0
    },
    ['@media (max-width:600px)']: {
      paddingRight: '15px',
      marginTop: 0
    }
  },
  rightSide: {
    width: '300px',
    minWidth: '300px',
    ['@media (max-width:600px)']: {
      marginBottom: '70px'
    }
  },
  title: {
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    marginBottom: '20px'
  },
  sectionTitleIndent: {
    marginBottom: '15px'
  },
  checkoutWrapper: {
    padding: 0
  },
  checkoutList: {
    maxHeight: '390px'
  },
  form: {
    margin: '3px 0 15px'
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  fieldFullWidth: {
    marginBottom: '18px',
    width: '100%'
  },
  field: {
    marginBottom: '18px',
    width: '47%'
  },
  shortField: {
    marginBottom: '18px',
    width: '24%'
  },
  longField: {
    marginBottom: '18px',
    width: '70%'
  },
  inputLabel: {
    fontWeight: 'bold'
  },
  expirationDateField: {
    width: '30%'
  },
  cvvField: {
    width: '17%'
  },
  userSection: {
    marginBottom: '15px'
  },
  radioButtons: {
    marginBottom: '5px'
  },
  expansionPanelDetailsRoot: {
    minHeight: '34px',
    padding: '20px 24px'
  },
  emptyExpansionPanelDetailsRoot: {
    minHeight: "unset",
    height: 0,
    padding: 0
  },
  expansionPanelRoot: {
    marginBottom: '12px !important',
    boxShadow: 'none',
    border: `1px solid ${theme.baseUI.color}`,
    overflow: 'hidden'
  },
  expPanelSummaryRoot: {
    minHeight: '55px !important'
  },
  expPanelSummaryExpanded: {
    borderBottom: `1px solid ${theme.baseUI.color}`,
    position: 'relative',
    '&:after': {
      display: 'block',
      content: '""',
      position: 'absolute',
      left: 0,
      top: 0,
      background: theme.baseUI.color,
      width: '100%',
      height: '100%',
      opacity: '.1'
    }
  },
  emptyExpPanelSummaryExpanded: {
    border: 0
  },
  expPanelSummaryContent: {
    border: 0,
    background: 'transparent',
    margin: '0 !important',
    position: 'relative',
    '&:after': {
      display: 'block',
      content: '""',
      position: 'absolute',
      left: 0,
      top: 0,
      background: 'transparent',
      width: '100%',
      height: '100%',
      opacity: '.1'
    }
  },
  expLabel: {
    display: 'flex',
    flexDirection: 'column',
    color: '#071B27'
  },
  fee: {
    color: '#3E5F77',
    fontWeight: 'normal'
  }
}));

const radioBtnStyles = makeStyles(theme => ({
  root: {
    color: theme.baseUI.color,
    fontSize: 18
  },
  checked: {
    color: theme.baseUI.color
  }
}));

export { useStyles, radioBtnStyles };
